import { Component } from '@angular/core';

import {MatTabsModule} from '@angular/material/tabs';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-home',
    imports: [MatTabsModule, RouterLink],
    templateUrl: './home.component.html',
    styleUrl: './home.component.sass'
})
export class HomeComponent {

}
